<template>
    <div class="magazin-list-entry">
        <p class="entry-subtitle">{{ item.$.subtitle }}</p>
        <h4 class="entry-title">{{ item.$.title }}</h4>
        <p class="entry-teaser">{{ stripHtml(item.$.lead_text) }}</p>
    </div>
</template>

<script>
import { Magazin } from '@/models/Magazin';
import { stripHtml } from '@/helpers/tools';

export default {
    props: {
        item: Magazin,
    },
    methods: {
        stripHtml,
    },
};
</script>
<style lang="scss" scoped>
.magazin-list-entry {
    max-width: 350px;
}
.entry-subtitle {
    font-size: 0.875rem;
    color: var(--gray-text-color);
    margin: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
.entry-title {
    font-size: 1rem;
    color: var(--nearblack-color);
    margin: 0;
    margin-top: 0.25rem;
    margin-bottom: 0.25rem;
    border-bottom: 1px solid var(--gray-border-color);
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.entry-teaser {
    font-size: 0.875rem;
    color: var(--gray-text-color);
    margin: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
</style>
